import axios from 'axios';
import { CONFIG_FILE } from './constants';

// ANY CHANGES TO THESE KEYS NEEDS TO BE REFLECTED IN THE VAULT SECRETS
export const config = {
  APP_URL: '',
  AUTH_URL: '',
  EHR_WEB_URL: '',
  HYLIA_API_URL: '',
  HYLIA_ASSETS_URL: '',
  MAMI_URL: '',
  PEAR002A_ASSETS_URL: '',
  PEARMD_WEB_URL: '',
  DD_APPLICATION_ID: '',
  DD_CLIENT_TOKEN: '',
  DD_ENV: 'dev',
  // These are the defaults for DataDog RUM, but they should be set to 'true' in Vault
  DD_TRACK_LONG_TASKS: 'false',
  DD_TRACK_RESOURCES: 'false',
  DD_TRACK_USER_INTERACTIONS: 'false',
};

export type Config = typeof config;

export function validateConfig(vaultConfig: any): Config {
  if (typeof vaultConfig === 'string') {
    throw new Error('Unable to load config.json');
  }

  const vaultKeysConfig = Object.keys(vaultConfig);
  const missingKeys = Object.keys(config).filter(
    (item: string) => vaultKeysConfig.indexOf(item) === -1,
  );

  if (missingKeys.length) {
    throw new Error(
      `Required keys are missing in config.json: ${missingKeys.join(': ')}`,
    );
  }

  return vaultConfig;
}

/* istanbul ignore next */
export async function fetchConfig(): Promise<Config> {
  try {
    const res = await axios.get(`/${CONFIG_FILE}`);
    const validatedConfig = validateConfig(res.data);
    Object.assign(config, validatedConfig);
    return validatedConfig;
  } catch (error: any) {
    console.error(error); // eslint-disable-line
    throw error;
  }
}

let fetchConfigPromise: Promise<Config>;

/**
 * Lazy-loads config json.
 * The promise is cached in memory and will resolve without making a network request on subsequent calls.
 */
export function getConfig(): Promise<Config> {
  if (!fetchConfigPromise) {
    fetchConfigPromise = fetchConfig();
  }
  return fetchConfigPromise;
}
